import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import DashboardStatistics from "../../containers/dashboard_container";
import Loader from "../universal/loader";
import { Header,Popup, Button, Icon,Tab } from "semantic-ui-react";
import FilterAttributes from "../../containers/filter_container";
import { withRouter } from "react-router-dom";
import moment from "moment";
import {BASE_URL, CUSTOM_REPORT} from "../../constants/app_routes";
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";

class LastInspectionsListing extends Component {
  constructor(props) {
    super(props);
    this.state = {isFetching:false}
  }

  componentDidMount() {
    this.props.getLastInspectionData(
    );
  }

  handleReport = (row, status, reportDetail) => {
    const mapStatus = ['pending', 'scheduled', 'confirmed', 'processing', 'submitted', 'completed', 'request_abort', 'aborted', 'request_cancel', 'cancelled'];
    if (reportDetail['custom_report_id']) {
        return (Object.assign(document.createElement('a'), { target: '_blank', href: "/report/custom_report/create/" + reportDetail['custom_report_id']}).click());
    }
    else {
        if ((this.props.userRole === 'clerk' && (mapStatus.indexOf(status) ===  4) || mapStatus.indexOf(status) === 5)  || (this.props.userRole === 'admin' && mapStatus.indexOf(status) === 5)) {
            return(this.handleDownload(reportDetail["report_id"], reportDetail))
        }
        else {
            return ( Object.assign(document.createElement('a'), { target: '_blank', href: "/report/create/" + row}).click())
        }
    }
};


    handleDownload = async (id, reportDetail) => {
        if (!this.state.isDownloading ){
            this.setState({isDownloading: true, showDownload: true,currentDownload:id});
            let URL = BASE_URL + "/report/download/" + id;
            //if(reportDetail['report_pdf_path']){
            //    URL = reportDetail['report_pdf_path'];
            //}
            let fileName = reportDetail['report_filename'];
            await handleFileDownload(URL, fileName,);
            this.setState({isDownloading: false,currentDownload:undefined});
            this.props.getLastInspectionData(
            );
            }
    };


  render() {
    const columns = [
      {
        Header: "Date",
        id: "inspection_date",
        accessor: (d) => d.inspection_time["inspection_date"],
        className: "date-width",
        headerClassName: "date-width",
        filterable: true,
        maxWidth: 140,
        Cell: ({ original, value }) => (
          <span>{moment(value, "YYYY-MM-DD").format("DD-MM-YYYY")}</span>
        ),
      },
      {
        Header: "Time",
        accessor: "inspection_time.inspection_start_time",
        className: "partTime-width",
        headerClassName: "partTime-width",
        filterable: true,
        maxWidth: 90,
      },
      {
        Header: "Company",
        accessor: "company_name",
        className: "left-aligned",
        maxWidth: 140,
        filterable: true,
      },
      {
        Header: "Furnishings",
        accessor: "property.furnishing_type",
        className: "format-capitalize",
        filterable: true,
        maxWidth: 100,
      },
      {
        Header: "Size",
        id: "Size",
        accessor: (d) => d.property["property_size"] + " Bed",
        headerClassName: "micro-width",
        className: "micro-width format-capitalize",
        filterable: true,
        maxWidth: 90,
      },
      {
        Header: "Job Type",
        accessor: "inspection_type",
        className: "formatcase mini-width",
        maxWidth: 100,
        filterable: true,
      },
      {
        Header: "Address",
        id: "property",
        accessor: (d) => d.property["address"],
        filterable: true
      },
      {
        Header: "Clerk",
        accessor: (d) => d.clerk? d["clerk"]: "Un Assigned",
        filterable: true,
        maxWidth:150,
        id: "clerk",
        Cell:({original,value}) => (<div>{<span className={!original.clerk ? "status-red assign-user" : ""}>{value}</span>}</div>)
      },
       {
        Header: "Created",
        accessor: "created_at",
        id:"created_at",
        filterable: true,
        maxWidth:150,
        Cell:({original,value}) => (
          <div>{moment(value).fromNow()}</div>
        )
      },
      {
        Header: "Updated",
        accessor: "updated_at",
        id: "updated_at",
        filterable: true,
        maxWidth:150,
        Cell:({original,value}) => (
          <div>{moment(value).fromNow()}</div>
        )
      },
    {
      Header: "Status",
      id: "edit",
      accessor: "status",
      sortable: false,
      maxWidth:150,
      Cell: ({ original, value }) => (
        <div>
          <Button size='mini' compact ><span className='format-capitalize'>
            {value}
            </span>
          </Button>
        </div>
      )
    },
  ];

  const extraColumn =       {
        Header: "Action",
        id: "inspection_id",
        accessor: "id",
        sortable: false,
        maxWidth:150,
        Cell: ({ original, value }) => (
          <div>
            <Button
              basic
              compact
              icon
              positive
              size="mini"
              onClick={() => {
                this.props.setFilter(
                  undefined,
                  undefined,
                  undefined,
                  original.id
                );
                this.props.history.push("/inspection");
              }}
            >
              <Icon name="eye" />
              View
            </Button>
              {this.props.userRole !== 'agent' ? <Button basic compact icon color='orange' size='mini'
                          disabled={!(original['user'] && original['user']['name'])}
                          as="a"
                          target="_blank"
                          onClick={() => {this.handleReport(original['report_id'], original['status'], original)} }
                          > Report <Icon
                      name='arrow right'/></Button>:<Button basic compact icon color='orange' size='mini'
                                                  disabled={!(original['user'] && original['user']['name'] && original['status'] === 'completed')}
                                                  as="a"
                                                  loading={this.state.currentDownload === original['report_id']}
                                                  target="_blank"
                                                  onClick={() => {
                                                    // console.log(original);
                                                    this.handleReport(original['report_id'], original['status'], original)
                                                  } }
                          > Download <Icon
                          name='arrow right'/></Button>
                      }
          </div>
        )
      }

  this.props.userRole == "agent" ? columns.push ({
    Header: "Download",
    id: "pdf_downloaded",
    accessor: "pdf_downloaded",
    sortable: true,
    maxWidth:150,
    Cell: ({ original, value }) => (
      <div>

       {original.pdf_downloaded ? <Button      onClick={() => {this.handleReport(original['report_id'], original['status'], original)} } color="green" size='mini' basic compact><span className='format-capitalize'>
          Downloaded
          </span>
        </Button>:<Button      onClick={() => {this.handleReport(original['report_id'], original['status'], original)} } basic color="red" size='mini' compact><span className='format-capitalize'>
          Not Downloaded
          </span>
        </Button> }
      </div>
    )
  }) : undefined
 
  let panes = [
    this.props.renderStatObject &&{ menuItem: {
    key: 'statistics',
    icon: 'chart bar',
    content: 'Statistics'
  }, render:()=>this.props.renderStatObject(this.props.data)}, {  menuItem: {
    key: 'recent',
    icon: 'clock',
    content: 'Last 50 Inspections'
  }, render:()=><React.Fragment>
              <Header size="large" textAlign="left">
                  <div className="content">{this.props.userRole === "agent" ? "Last 50 Inspections Completed" : "Last 50 Inspections Booked"}</div>
              </Header><h3  className="left-aligned">Booked today: {this.props.lastInspectionData.booked_today||0}</h3>
          <ReactTable
            data={this.props.lastInspectionData.inspections}
            columns={[...columns,extraColumn]}
            defaultFilterMethod={(filter, row, column) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .toUpperCase()
                    .startsWith(filter.value.toUpperCase())
                : true;}}
            defaultPageSize={10}
            minRows={5}
            defaultSorted={this.props.userRole !== "admin" ? [ { id: "updated_at",  desc: true }]: [ {id: "created_at",desc: true } ]}
            noDataText="No Inspection Data"  /></React.Fragment>},
            this.props.userRole !=="agent" && { menuItem: {
    key: 'unassigned-inspections',
    icon: 'tasks',
    content: 'Available Unassigned Inspections'
  }, render:()=><React.Fragment>
                 <Header size="large" textAlign="left">
                  <div className="content"> Available Unassigned Inspections </div>
              </Header><h3  className="left-aligned">Contact Bookings if interested in any of the below</h3>
          <ReactTable
            data={this.props.lastInspectionData.unassigned}
            columns={[...columns]}
            defaultFilterMethod={(filter, row, column) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .toUpperCase()
                    .startsWith(filter.value.toUpperCase())
                : true;}}
            defaultPageSize={10}
            minRows={5}
defaultSorted={[{ id: "inspection_date", desc: false }]}
            noDataText="No Inspection Data"  /></React.Fragment>}]

    return (
      <div style={{ width: "100%", margin: "auto" }} className="center-aligned">
        {!(this.props.isLastInspectionFetching || this.state.isFetching) && (
          <Tab panes={panes} />  
        )}
        {(this.props.isLastInspectionFetching || this.state.isFetching)  && (
          <Loader contain={true} customText="Loading Dashboard" />
        )}
        <div style={{ minHeight: "50px" }}></div>
        {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
      </div>
    );
  }
}

export default DashboardStatistics(
  FilterAttributes(withRouter(LastInspectionsListing))
);



// WEBPACK FOOTER //
// ./src/views/dashboard/last_inspections_booked.js